<usb-base-item
  [item]="item"
  [styleSidebar]="styleSidebar"
  [currencyAgency]="currencyAgency"
  [currencies]="currencies"
  [clientsSettingAppBooking]="clientsSettingAppBooking"
>
  <!-- Puerto -->
  <div *ngIf="location" class="d-flex flex-column mb-3" style="gap: 5px">
    <a [href]="mapUrl" target="_blank" rel="noopener" class="d-flex align-items-center boat-map-link" style="gap: 4px">
      <svg style="width: 15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 398.49 517.42">
        <path d="M199.25,308.32A109.08,109.08,0,1,1,308.32,199.25,109.2,109.2,0,0,1,199.25,308.32Zm0-180.33a71.26,71.26,0,1,0,71.26,71.26A71.33,71.33,0,0,0,199.25,128Z"/>
        <path d="M186.8,506.53C179.17,499.85,0,341.48,0,199.25,0,89.38,89.38,0,199.25,0S398.49,89.38,398.49,199.25c0,142.21-179.17,300.6-186.79,307.27l-12.45,10.9ZM199.25,37.82c-89,0-161.43,72.41-161.43,161.43,0,50.82,29.6,114.76,85.6,184.89a844.93,844.93,0,0,0,73.87,80.56l2,1.88,2-1.88a848.9,848.9,0,0,0,73.87-80.56c56-70.13,85.59-134.07,85.59-184.89C360.67,110.23,288.26,37.82,199.25,37.82Z"/>
      </svg>
      <span class="boat-label boat-label--strong">Ver mapa</span>
    </a>
    <p class="boat-label boat-label--muted mb-0">{{ location }}</p>
  </div>

  <!-- Cabinas / capacidad / baños -->
  <div class="d-flex flex-column mb-3" style="gap: 10px">
    <div class="d-flex align-items-start" style="gap: 6px">
      <img width="20" height="20" src="../../../../../../assets/icons/itinerary/cama_peq.svg" alt="" style="opacity: 0.6" />
      <div class="d-flex flex-column">
        <span class="boat-label boat-label--strong">Cabinas</span>
        <span class="boat-label">{{ boat?.cabinCount || 0 }} Cabinas</span>
        <span *ngIf="skipperIncluded" class="boat-label">(+1p/ Capitán)</span>
      </div>
    </div>

    <div class="d-flex align-items-start" style="gap: 6px">
      <img width="20" height="20" src="../../../../../../assets/icons/search-result/persona.svg" alt="" style="opacity: 0.6" />
      <div class="d-flex flex-column">
        <span class="boat-label boat-label--strong">Capacidad</span>
        <span class="boat-label">{{ boat?.peopleMax || 0 }} Pax</span>
      </div>
    </div>

    <div class="d-flex align-items-start" style="gap: 6px">
      <img width="20" height="20" src="../../../../../../assets/icons/search-result/hotel/NIÑO.svg" alt="" style="opacity: 0.6" />
      <div class="d-flex flex-column">
        <span class="boat-label boat-label--strong">Baños</span>
        <span class="boat-label">{{ boat?.wc || 0 }} Baños</span>
      </div>
    </div>
  </div>

  <!-- Salida / llegada -->
  <div class="row mb-3">
    <div class="col-6 d-flex flex-column">
      <span class="boat-label">Check In:</span>
      <span class="boat-label boat-label--strong">{{ item.arrivalDate | date: "EEE. dd MMM yyyy" }}</span>
      <span *ngIf="item.checkInTime" class="boat-label boat-label--strong">{{ item.checkInTime }} hs</span>
    </div>
    <div class="col-6 d-flex flex-column">
      <span class="boat-label">Check Out:</span>
      <span class="boat-label boat-label--strong">{{ item.departureDate | date: "EEE. dd MMM yyyy" }}</span>
      <span *ngIf="item.checkOutTime" class="boat-label boat-label--strong">{{ item.checkOutTime }} hs</span>
    </div>
  </div>
</usb-base-item>
